import { AnimationWorkflow } from "@/lib/hooks/useAnimationWorkflow";

// Simple basic animation workflows - single concept animations
export const fadeInWorkflow = (duration: number = 500): AnimationWorkflow => ({
  id: "fade-in",
  name: "Fade In Animation",
  steps: [
    {
      id: "start-hidden",
      name: "Start Hidden",
      duration: 0,
      opacity: 0,
      transform: {
        translateY: 10,
      },
    },
    {
      id: "fade-in-step",
      name: "Fade In",
      duration,
      easing: "ease-in-out",
      opacity: 1,
      transform: {
        translateY: 0,
      },
    },
  ],
});

export const verticalFlipWorkflow = (
  duration: number = 2000,
): AnimationWorkflow => ({
  id: "vertical-flip",
  name: "Vertical Flip Animation",
  steps: [
    {
      id: "flip-step",
      name: "Flip around vertical center",
      duration,
      easing: "cubic-bezier(0.4, 0, 0.2, 1)",
      transform: {
        rotateY: "180deg",
      },
    },
  ],
});

export const shrinkWorkflow = (duration: number = 300): AnimationWorkflow => ({
  id: "shrink",
  name: "Shrink Animation",
  steps: [
    {
      id: "shrink-down",
      name: "Shrink Down",
      duration,
      easing: "ease-out",
      transform: {
        scale: 0.85,
      },
    },
  ],
});

export const shrinkBounceWorkflow = (
  duration: number = 200,
): AnimationWorkflow => ({
  id: "shrink-bounce",
  name: "Shrink Bounce Effect",
  steps: [
    {
      id: "shrink-down",
      name: "Press Down",
      duration: duration / 2,
      easing: "ease-out",
      transform: {
        scale: 0.95,
      },
    },
    {
      id: "shrink-up",
      name: "Release Up",
      duration: duration / 2,
      easing: "ease-in",
      transform: {
        scale: 1.0,
      },
    },
  ],
});

export const fadeOutWorkflow = (duration: number = 500): AnimationWorkflow => ({
  id: "fade-out",
  name: "Fade Out Animation",
  steps: [
    {
      id: "fade-out-step",
      name: "Fade Out",
      duration,
      easing: "ease-in-out",
      opacity: 0,
    },
  ],
});

export const cardMoveWorkflow = (
  targetX: string = "-40vw",
  targetY: string = "-20vh",
  targetScale: number = 0.4,
  onMoveComplete?: () => void,
): AnimationWorkflow => ({
  id: "card-move",
  name: "Card Movement Animation",
  steps: [
    {
      id: "move-to-target",
      name: "Move to Target Position",
      duration: 1000,
      easing: "cubic-bezier(0.4, 0, 0.2, 1)",
      transform: {
        translateX: targetX,
        translateY: targetY,
        scale: targetScale,
      },
    },
  ],
  onWorkflowComplete: onMoveComplete,
});
